if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // ------- Hjælpere -------
      updateCartBubbleCount(count) {
        // Prøv flere mulige containere – forskellige temaer bruger forskellig markup
        const container =
          document.querySelector('#cart-icon-bubble') ||
          document.querySelector('[data-cart-icon-bubble]') ||
          document.querySelector('.header__icon--cart') ||
          document.querySelector('.shopify-section-header') ||
          null;

        if (!container) return;

        // Find eller opret selve boblen
        let bubble =
          container.querySelector('.cart-count-bubble') ||
          container.querySelector('[data-cart-count]') ||
          null;

        if (!bubble) {
          // Opret en simpel boble, hvis temaet ikke har en endnu
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          // Minimal styling så den kan ses (kan erstattes af temaets css)
          bubble.style.display = 'inline-flex';
          bubble.style.alignItems = 'center';
          bubble.style.justifyContent = 'center';
          bubble.style.minWidth = '18px';
          bubble.style.height = '18px';
          bubble.style.padding = '0 6px';
          bubble.style.borderRadius = '999px';
          bubble.style.background = '#0A1D48';
          bubble.style.color = '#fff';
          bubble.style.fontSize = '12px';
          bubble.style.lineHeight = '18px';
          bubble.style.marginLeft = '6px';
          container.appendChild(bubble);
        }

        // Sæt tal og vis/skjul
        bubble.textContent = String(count);
        // Skjul hvis 0
        if (count === 0) {
          bubble.style.display = 'none';
        } else {
          bubble.style.display = 'inline-flex';
        }
      }

      refreshCartBubble() {
        // Hurtig, stabil måde: hent /cart.js og brug item_count
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then((res) => res.json())
          .then((cart) => {
            this.updateCartBubbleCount(cart.item_count || 0);
          })
          .catch((e) => console.error('Kunne ikke opdatere kurv-boble:', e));
      }

      showToast(message = 'Produkt tilføjet til kurven') {
        // Lille, diskret toast (kan slettes hvis du ikke vil have den)
        const notice = document.createElement('div');
        notice.textContent = message;
        Object.assign(notice.style, {
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: '#0A1D48',
          color: '#fff',
          padding: '12px 18px',
          borderRadius: '8px',
          zIndex: '9999',
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif',
          fontSize: '14px',
          boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
          opacity: '0',
          transition: 'opacity .25s ease'
        });
        document.body.appendChild(notice);
        requestAnimationFrame(() => (notice.style.opacity = '1'));
        setTimeout(() => {
          notice.style.opacity = '0';
          setTimeout(() => notice.remove(), 250);
        }, 1800);
      }

      // ------- Submit flow -------
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // 1) Fortæl resten af temaet at kurven er opdateret
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // 2) Opdater kurv-boblen uden at åbne drawer
            this.refreshCartBubble();

            // 3) Diskret toast (valgfrit)
            this.showToast('Produkt tilføjet til kurven');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
